module.exports = __webpack_public_path__ + "img/company.0ede7515.0ede7515.png";